import { memo, useState, useCallback, useEffect } from 'react';
import { Row, Col, Container } from "react-bootstrap";
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { BzCard, BzChip } from "../../components";
import { ZeroStates } from '../../containers';
import { TL_INDEX, ORDER_TYPES, ORDERS_TABKEY, LOCATIONS, SESSION_STORAGE_KEYS } from '../../utils/global_variables';
import { StatusChip } from '../Orders';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { useWFHMessages } from '../../hooks';
import { sendTouchlineRequest } from '../../apis/web_socket';
import { getScripOrderInfo } from '../../redux/actions/orders';
import { getWfhTouchlineLastTick } from '../../redux/actions/wfh';
import { isUserIsAGuest,setStorageWithMultiTabCheckWithoutEncryption } from '../../utils/global_functions';


const OpenOrderMultiScrip = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { allOpenOrders: getMultiScripOrder } = useSelector(state => state.orders.getMultiLegOrder);

    const [arrMultiScripOrder, setArrMultiScripOrder] = useState([]);



    useEffect(() => {
        if (getMultiScripOrder?.length) {
            setArrMultiScripOrder(getMultiScripOrder);
        }

    }, [getMultiScripOrder]);

    const handlePlaceOrder = () => {
        if (!isUserIsAGuest('buy_sell')) {//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
            dispatch(handleModal([{ "ORDER_ENTRY_MODAL": true }]));
            dispatch(handleModalData({ data: { orderEntryTab: ORDER_TYPES.MULTI_SCRIP, activeTabKey: ORDER_TYPES.MULTI_LEG } }));
            // dispatch(handleModalData({ data: { orderEntryTab: 'multi_scrip', activeTabKey: ORDER_TYPES.MULTI_LEG } }), true);
            const objScrpinfo = { activeExchangeName: '', isBuySell: 0, scripData: [] };
            dispatch(getScripOrderInfo(objScrpinfo));
        } else { }//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End


    };

    const navigate = useNavigate();

    const handleOrderHistory = (id, orderType) => {
        let path = `/orders?section=${orderType === 'Spread' ? ORDER_TYPES.SPREAD : ORDER_TYPES.MULTI_LEG}&ordertype=${ORDERS_TABKEY.OPEN_ORDERS}`;
        navigate(path, { state: id });
        setStorageWithMultiTabCheckWithoutEncryption(SESSION_STORAGE_KEYS.SEARCH_PARAMS, 'true');
    };


    useEffect(() => {
        if (arrMultiScripOrder?.length > 0) {
            const arrTouchlineReq = arrMultiScripOrder?.map(scrip => {
                return { exchangeId: scrip?.segment_id, token: scrip?.spread_token };
            });
            sendTouchlineRequest(arrTouchlineReq);
        }
    }, [arrMultiScripOrder]);


    const handleMultiScripLtp = useCallback((arrTouchLineData) => {
        arrMultiScripOrder?.forEach((each, i) => {

            if (each?.segment_id + "_" + each.spread_token + "_"
                + each?.order_id
                === arrTouchLineData[TL_INDEX.SEGMENT_ID] + '_' + arrTouchLineData[TL_INDEX.TOKEN] + "_"
                + each?.order_id
            ) {
                const objScripToBeUpdated = each;
                objScripToBeUpdated.ltp = arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE];

            }
            if (arrMultiScripOrder.length > 0) {
                setArrMultiScripOrder([...arrMultiScripOrder]);
            }
        });
    }, [arrMultiScripOrder]);

    useWFHMessages('touchline', (e) => {
        const arrTouchlineReq = [...e.detail];
        handleMultiScripLtp(arrTouchlineReq);

    });

    useEffect(() => {
        const objLastTickData = dispatch(getWfhTouchlineLastTick());
        if (Object.keys(objLastTickData).length > 0) {
            if (getMultiScripOrder?.length > 0) {
                getMultiScripOrder?.forEach((each) => {
                    const arrLastTickData = objLastTickData[each?.segment_id + "_" + each?.spread_token];
                    if (arrLastTickData?.length > 0) {
                        handleMultiScripLtp(arrLastTickData);
                    }
                });
            }
        } else { }
    }, [getMultiScripOrder, dispatch]);

    // const getMultiScripOpenOrder = getMultiScripOrder?.filter((each) => each?.status === ALL_ORDERS_STATUS.ORDER_STATUS_PENDING || each?.status == ALL_ORDERS_STATUS.ORDER_STATUS_OPEN || each?.status === ALL_ORDERS_STATUS.ORDER_STATUS_OMSXMITTED || each?.status === ALL_ORDERS_STATUS.ORDER_STATUS_OMS_XMITTED || each?.status === ALL_ORDERS_STATUS.ORDER_STATUS_PENDING);

    return (
        <>
            {
                location.pathname === LOCATIONS.WATCHLIST ?
                    <Container fluid className='p-0 px-2 mt-3 horizontal-scroll-wrap'>
                        {getMultiScripOrder?.length > 0 ?
                            <Row className='g-0'>
                                <Col className='p-0'>
                                    <div className='transparent-card-wrap'>
                                        {getMultiScripOrder && getMultiScripOrder?.map((each) => {
                                            return (
                                                <BzCard key={each?.order_id} className='transparent-card cursor-pointer bdr-btm'>
                                                    <Row className='g-0 mb-2'>
                                                        <Col md={8} className='justify-content-start align-self-center'>
                                                            <div className='font-medium font-size3 color-text float-start'>{each?.spread_symbol}</div>
                                                        </Col>
                                                        <Col md={4} className='d-flex justify-content-end align-self-center'>
                                                            <StatusChip data={each} />
                                                        </Col>
                                                    </Row>
                                                    <Row className='g-0 mb-2'>
                                                        <Col md={6} className='d-flex justify-content-start align-self-center'>
                                                            <div className='chips-wrap'>
                                                                <BzChip className='exchange-chip me-2'>{each?.exchange?.split('_')[0]} </BzChip>
                                                            </div>
                                                            <div className='font-regular font-size2 color-subtext'>{each?.leg_no_1?.convertedDate} &nbsp; {each?.leg_no_1?.instrument?.slice(0, 3)}</div>
                                                        </Col>
                                                        <Col md={6} className='d-flex justify-content-end align-self-center'>
                                                            <div className='font-regular font-size3 color-subtext'>
                                                                <span className='font-medium font-size2 color-text'>LTP: ₹{each?.ltp}</span>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className='g-0 mb-2'>
                                                        <Col md={6} className='chips-wrap'>
                                                            <div className='d-flex justify-content-start align-self-center'>
                                                                <div className='d-flex align-self-center font-regular font-size1 color-subtext me-2'>{each?.time}, {each?.convertedDate}</div>
                                                                {each.orderType === 'Multi Leg' && <BzChip className='chips primary-chip text-capitalize'>{each?.orderType}</BzChip>}
                                                                <BzChip className='chips primary-chip text-capitalize'>{each?.leg_indicator}</BzChip>
                                                            </div>
                                                        </Col>
                                                        <Col md={6} className='d-flex justify-content-end align-self-center'>
                                                            <div className='font-regular font-size3 color-text'>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </BzCard>
                                            );
                                        })}
                                    </div>
                                </Col>
                            </Row>
                            :
                            <div className='zero-state-alerts zero-state-alerts-lg'>
                                <ZeroStates handleOnClick={handlePlaceOrder} subText="You are yet to place an order" icon='icon-64 icon-nodata mb-3 mrgauto' btnText='Place an order now' btnClass='btn btn-md btn-outline mt-2' />
                            </div>
                        }
                    </Container>
                    :
                    (
                        location.pathname === LOCATIONS.DASHBOARDS ?
                            <Container fluid className='p-0 pe-2'>
                                {
                                    getMultiScripOrder?.length > 0 ?
                                        <Row className='g-0'>
                                            <Col className='p-0'>
                                                <div className='transparent-card-wrap'>
                                                    {getMultiScripOrder?.map((each) => (
                                                        <BzCard key={each?.order_id} className='p-0 py-2 bdr-card-btm cursor-pointer' onClick={() => handleOrderHistory(each?.order_id, each?.orderType)} >
                                                            <Row className='g-0 mb-2'>
                                                                <Col md={8} className='justify-content-start align-self-center'>
                                                                    <div className='font-medium font-size3 color-text'>{each?.spread_symbol}</div>
                                                                </Col>
                                                                <Col md={4} className='d-flex justify-content-end align-self-center'>
                                                                    <div className='orderstatus-chips-wrap'>
                                                                        <StatusChip data={each} />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row className='g-0 mb-2'>
                                                                <Col md={6} className='d-flex justify-content-start align-self-center'>
                                                                    <div className='chips-wrap'>
                                                                        <BzChip className='exchange-chip me-2'>{each?.exchange?.split('_')[0]}</BzChip>
                                                                    </div>
                                                                    <div className='font-regular font-size2 color-subtext'>{each?.leg_no_1?.convertedDate} &nbsp; {each?.leg_no_1?.instrument?.slice(0, 3)}</div>
                                                                </Col>
                                                                <Col md={6} className='d-flex justify-content-end align-self-center'>
                                                                    <div className='font-regular font-size3 color-subtext'>
                                                                        <span className='font-medium font-size2 color-text'>LTP: ₹{each?.ltp}</span>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row className='g-0 mb-2'>
                                                                <Col md={10} className='chips-wrap'>
                                                                    <div className='d-flex justify-content-start align-self-center'>
                                                                        <div className='d-flex align-self-center font-regular font-size1 color-subtext me-2'> {each?.time}, {each?.convertedDate}</div>
                                                                        {each.orderType === 'Multi Leg' && <BzChip className='chips primary-chip text-capitalize'>{each?.orderType}</BzChip>}
                                                                        <BzChip className='chips primary-chip text-capitalize'>{each?.leg_indicator}
                                                                        </BzChip>
                                                                    </div>
                                                                </Col>
                                                                <Col md={6} className='d-flex justify-content-end align-self-center'>
                                                                    <div className='font-regular font-size2 color-subtext'>

                                                                    </div>

                                                                </Col>
                                                            </Row>
                                                        </BzCard>
                                                    ))}
                                                </div >
                                            </Col >
                                        </Row >
                                        :
                                        <div className='zero-state-alerts zero-state-alerts-md'>
                                            <ZeroStates subText="You are yet to place an order" icon='icon-64 icon-nodata mb-3 mrgauto' />
                                        </div>
                                }
                            </Container >
                            : null
                    )
            }
        </>

    );
};

export default memo(OpenOrderMultiScrip);